export default __webpack_public_path__ + "static/media/u-14.ec0cae9b.png";